import { Link } from "react-router-dom";
import BrandMark from "./BrandMark";

const FOOTER_LINKS = [
  { to: "/privacy", label: "Privacy" },
  { to: "/terms", label: "Terms" },
  { to: "/contact", label: "Contact" },
  { to: "/faq", label: "FAQ" },
  { to: "/help", label: "Help" },
];

export default function MarketingLayout({ children, dataTestId }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#FAFAF9] text-[#0F172A]" data-testid={dataTestId}>
      {/* Top nav */}
      <header className="bg-[#1A2332] text-white border-b border-[#243044]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5 text-white" data-testid="marketing-brand-link">
            <BrandMark size={36} className="flex-shrink-0 rounded-md" />
            <span className="font-display text-lg sm:text-xl font-bold tracking-tight">
              ezItemizer
            </span>
          </Link>
          <Link
            to="/login"
            data-testid="marketing-signin-link"
            className="inline-flex items-center gap-1.5 text-xs sm:text-sm font-bold uppercase tracking-widest text-white/80 hover:text-[#FF9800] transition-colors"
          >
            Sign in
          </Link>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1">{children}</main>

      {/* Footer */}
      <footer className="bg-[#1A2332] text-white/60 border-t border-white/10 mt-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 mb-8">
            <Link to="/" className="flex items-center gap-2.5">
              <BrandMark size={32} className="rounded-md" />
              <span className="font-display font-bold text-white text-base">
                ezItemizer
              </span>
              <span className="text-xs uppercase tracking-widest text-white/40 ml-3 hidden sm:inline">
                Inventory Control
              </span>
            </Link>
            <nav className="flex flex-wrap items-center gap-x-6 gap-y-2">
              {FOOTER_LINKS.map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  className="text-xs font-bold uppercase tracking-widest hover:text-[#FF9800] transition-colors"
                >
                  {l.label}
                </Link>
              ))}
            </nav>
          </div>
          <div className="pt-6 border-t border-white/10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-xs font-mono uppercase tracking-widest">
            <span>© {new Date().getFullYear()} ezItemizer · All rights reserved</span>
            <a
              href="https://gadgetguymedia.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-credit-ggm"
              className="hover:text-[#FF9800] transition-colors"
            >
              Website Designed &amp; Built by <span className="text-[#FF9800]">Gadget Guy Media</span>
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

/** Pretty-print container for prose-heavy legal pages. */
export function MarketingProse({ title, kicker, lastUpdated, children, dataTestId }) {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-16 sm:py-24" data-testid={dataTestId}>
      <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#FF9800]">
        {kicker}
      </div>
      <h1 className="font-display font-black text-4xl sm:text-5xl mt-3 leading-tight">
        {title}
      </h1>
      {lastUpdated && (
        <p className="mt-4 text-xs font-mono uppercase tracking-widest text-zinc-500">
          Last updated · {lastUpdated}
        </p>
      )}
      <div className="mt-10 prose-marketing space-y-6 text-zinc-700 leading-relaxed">
        {children}
      </div>
    </div>
  );
}
